import React, { useEffect, useState } from 'react';
import { Box, Text, FormControl, FormLabel, Input, Select, Button, SimpleGrid, Divider } from '@chakra-ui/react';
import { useCommitteeContext } from '../context/CommitteeContext';
import { committeeMembers } from '../components/CommitteeSidebar';
const TEAL = '#00897B';
const BORDER_COLOR = '#006666';
function parseName(fullName: string): {
  firstName: string;
  lastName: string;
} {
  if (!fullName || fullName === 'Vacant') return {
    firstName: '',
    lastName: ''
  };
  const parts = fullName.trim().split(' ');
  return {
    firstName: parts[0] || '',
    lastName: parts.slice(1).join(' ') || ''
  };
}
const inputStyles = {
  borderColor: 'gray.300',
  focusBorderColor: TEAL,
  _hover: {
    borderColor: TEAL
  },
  size: 'sm' as const,
  bg: 'white'
};
const labelStyles = {
  fontSize: 'xs' as const,
  fontWeight: '600' as const,
  color: TEAL,
  textTransform: 'uppercase' as const,
  letterSpacing: '0.05em',
  mb: 0.5
};
export function CommitteePage() {
  const {
    selectedIndex
  } = useCommitteeContext();
  const selected = committeeMembers[selectedIndex];
  const {
    firstName: initFirst,
    lastName: initLast
  } = parseName(selected.name);
  const [firstName, setFirstName] = useState(initFirst);
  const [lastName, setLastName] = useState(initLast);
  const [company, setCompany] = useState('');
  const [homePhone, setHomePhone] = useState('');
  const [cell, setCell] = useState('');
  const [email, setEmail] = useState('');
  const [street, setStreet] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zip, setZip] = useState('');
  const [startDate, setStartDate] = useState('');
  const [termEndDate, setTermEndDate] = useState('');
  useEffect(() => {
    const {
      firstName: f,
      lastName: l
    } = parseName(committeeMembers[selectedIndex].name);
    setFirstName(f);
    setLastName(l);
    setCompany('');
    setHomePhone('');
    setCell('');
    setEmail('');
    setStreet('');
    setCity('');
    setState('');
    setZip('');
    setStartDate('');
    setTermEndDate('');
  }, [selectedIndex]);
  const handleSave = () => {
    console.log('Saving committee member...');
  };
  return <Box px={6} py={3} maxW="700px" data-id="element-239">
      <Text fontSize="xl" fontWeight="bold" color="black" mb={3} data-id="element-240">
        Edit Committee Member
      </Text>

      <Box border={`2px solid ${BORDER_COLOR}`} borderRadius="md" bg="white" p={4} data-id="element-241">
        {/* Name row */}
        <SimpleGrid columns={2} spacing={3} mb={3} data-id="element-242">
          <FormControl data-id="element-243">
            <FormLabel {...labelStyles} data-id="element-244">First Name</FormLabel>
            <Input {...inputStyles} value={firstName} onChange={e => setFirstName(e.target.value)} placeholder="First Name" data-id="element-245" />
          </FormControl>
          <FormControl data-id="element-246">
            <FormLabel {...labelStyles} data-id="element-247">Last Name</FormLabel>
            <Input {...inputStyles} value={lastName} onChange={e => setLastName(e.target.value)} placeholder="Last Name" data-id="element-248" />
          </FormControl>
        </SimpleGrid>

        <FormControl mb={3} data-id="element-249">
          <FormLabel {...labelStyles} data-id="element-250">Company/Farm Name</FormLabel>
          <Input {...inputStyles} value={company} onChange={e => setCompany(e.target.value)} placeholder="Company/Farm Name" data-id="element-251" />
        </FormControl>

        {/* Address block */}
        <FormControl mb={3} data-id="element-252">
          <FormLabel {...labelStyles} data-id="element-253">Street Address</FormLabel>
          <Input {...inputStyles} value={street} onChange={e => setStreet(e.target.value)} placeholder="Street Address" data-id="element-254" />
        </FormControl>

        <SimpleGrid columns={3} spacing={3} mb={3} data-id="element-255">
          <FormControl data-id="element-256">
            <FormLabel {...labelStyles} data-id="element-257">City</FormLabel>
            <Input {...inputStyles} value={city} onChange={e => setCity(e.target.value)} placeholder="City" data-id="element-258" />
          </FormControl>
          <FormControl data-id="element-259">
            <FormLabel {...labelStyles} data-id="element-260">State</FormLabel>
            <Input {...inputStyles} value={state} onChange={e => setState(e.target.value)} placeholder="State" maxLength={2} data-id="element-261" />
          </FormControl>
          <FormControl data-id="element-262">
            <FormLabel {...labelStyles} data-id="element-263">Zip</FormLabel>
            <Input {...inputStyles} value={zip} onChange={e => setZip(e.target.value)} placeholder="Zip" data-id="element-264" />
          </FormControl>
        </SimpleGrid>

        {/* Phone fields */}
        <SimpleGrid columns={2} spacing={3} mb={3} data-id="element-265">
          <FormControl data-id="element-266">
            <FormLabel {...labelStyles} data-id="element-267">Home/Business Phone</FormLabel>
            <Input {...inputStyles} value={homePhone} onChange={e => setHomePhone(e.target.value)} placeholder="Home/Business Phone" type="tel" data-id="element-268" />
          </FormControl>
          <FormControl data-id="element-269">
            <FormLabel {...labelStyles} data-id="element-270">Cell</FormLabel>
            <Input {...inputStyles} value={cell} onChange={e => setCell(e.target.value)} placeholder="Cell" type="tel" data-id="element-271" />
          </FormControl>
        </SimpleGrid>

        {/* Email */}
        <FormControl mb={3} data-id="element-272">
          <FormLabel {...labelStyles} data-id="element-273">Email</FormLabel>
          <Input {...inputStyles} value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" type="email" data-id="element-274" />
        </FormControl>

        <Divider borderColor="gray.200" my={3} data-id="element-275" />

        {/* Dates */}
        <SimpleGrid columns={2} spacing={3} mb={4} data-id="element-276">
          <FormControl data-id="element-277">
            <FormLabel {...labelStyles} data-id="element-278">Term Start Date</FormLabel>
            <Input {...inputStyles} value={startDate} onChange={e => setStartDate(e.target.value)} type="date" data-id="element-279" />
          </FormControl>
          <FormControl data-id="element-280">
            <FormLabel {...labelStyles} data-id="element-281">Term End Date</FormLabel>
            <Input {...inputStyles} value={termEndDate} onChange={e => setTermEndDate(e.target.value)} type="date" data-id="element-282" />
          </FormControl>
        </SimpleGrid>

        <Button bg="#0d6dfc" color="white" px={8} size="sm" borderRadius="md" fontWeight="semibold" _hover={{
        bg: '#0b5fd9'
      }} _active={{
        bg: '#0a52be'
      }} onClick={handleSave} data-id="element-283">
          Save
        </Button>
      </Box>
    </Box>;
}